export function setRedirectUri( uri ) {
  return {
    type: 'SET_REDIRECT_URI',
    payload: uri
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js